import { IFin } from "./IFin";

export class fin_api {

    public static save:string = "/api/fin/save"
    public static find_by_id:string = "/api/fin/find_by_id"
}

export interface IFinSvc {

    save(fin:IFin):Promise<IFin | undefined>;
    find_by_id(tree_id:string):Promise<IFin | undefined>;

}
    